import { render, staticRenderFns } from "./AuthButtons.vue?vue&type=template&id=55ac2ea9&scoped=true"
import script from "./AuthButtons.vue?vue&type=script&lang=js"
export * from "./AuthButtons.vue?vue&type=script&lang=js"
import style0 from "./AuthButtons.vue?vue&type=style&index=0&id=55ac2ea9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ac2ea9",
  null
  
)

export default component.exports